import { render, staticRenderFns } from "./UserGroup.vue?vue&type=template&id=548a868c"
import script from "./UserGroup.vue?vue&type=script&lang=ts"
export * from "./UserGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports